import { useSearchParams } from "react-router";
import { LoginForm } from "@/components/login-form";
import { usePageMeta } from "../use-page-meta";

const NOTICES: Record<string, string> = {
  confirm: "인증 링크가 만료되었거나 올바르지 않아요. 다시 가입하거나 로그인해주세요.",
  deleted: "회원 탈퇴가 완료되었어요. 이용해주셔서 감사합니다.",
};

export default function LoginPage() {
  const [params] = useSearchParams();
  usePageMeta("/auth/login", "로그인");

  // 쿼리 값을 그대로 화면에 찍지 않고, 정해둔 키에 해당하는 문구만 보여준다.
  const message = NOTICES[params.get("error") ?? ""] ?? NOTICES[params.get("notice") ?? ""] ?? null;

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 p-6">
      {message ? (
        <p
          className="w-full max-w-sm rounded-lg border border-border bg-muted px-4 py-3 text-center text-sm"
          role="status"
        >
          {message}
        </p>
      ) : null}
      <LoginForm />
    </div>
  );
}
